// Grade 2026/02 transcrita dos PDFs da UNIFENAS-BH.
// O campo sourcePdf preserva as tabelas e o texto extraídos, inclusive escalas de ambulatório.
// As datas dos blocos vêm do calendário já cadastrado em ../data.js; os PDFs de horário não as informam.
// ESTRUTURA DIFERENTE: grade única por semestre; turmas A/B/C têm atividades distintas.
import sourcePdf from "./sources/period4.json";
const periodDataset = {
  label: "4º período",
  syndromes: {
  "geral": {
    "name": "Grade geral",
    "short": "Geral"
  }
},
  blocks: [
  {
    "number": 1,
    "start": "2026-07-28",
    "end": "2026-08-21",
    "label": "1º bloco"
  },
  {
    "number": 2,
    "start": "2026-08-24",
    "end": "2026-09-25",
    "label": "2º bloco"
  },
  {
    "number": 3,
    "start": "2026-09-28",
    "end": "2026-10-30",
    "label": "3º bloco"
  },
  {
    "number": 4,
    "start": "2026-11-03",
    "end": "2026-12-04",
    "label": "4º bloco"
  }
],
  defaultRotations: {
  "A": {
    "1": "geral",
    "2": "geral",
    "3": "geral",
    "4": "geral"
  },
  "B": {
    "1": "geral",
    "2": "geral",
    "3": "geral",
    "4": "geral"
  },
  "C": {
    "1": "geral",
    "2": "geral",
    "3": "geral",
    "4": "geral"
  }
},
  baseSchedule: {
  "geral": {
    "1": {
      "am1": {
        "1": {
          "code": "PMCo",
          "title": "Prática médica na comunidade · oficina",
          "professor": "Renata Lima",
          "location": "Sala301",
          "kind": "class"
        },
        "2": {
          "code": "PMCo",
          "title": "Prática médica na comunidade · oficina",
          "professor": "Renata Lima",
          "location": "Sala301",
          "kind": "class"
        },
        "3": {
          "code": "PMCo",
          "title": "Prática médica na comunidade · oficina",
          "professor": "Renata Lima",
          "location": "Sala301",
          "kind": "class"
        },
        "4": {
          "code": "PMCo",
          "title": "Prática médica na comunidade · oficina",
          "professor": "Renata Lima",
          "location": "Sala301",
          "kind": "class"
        }
      },
      "am2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Alice Medeiros",
          "location": "Acolher convivência sênior",
          "kind": "class"
        },
        "4": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Alice Medeiros",
          "location": "Acolher convivência sênior",
          "kind": "class"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Alice Medeiros",
          "location": "Acolher convivência sênior",
          "kind": "class"
        },
        "4": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Alice Medeiros",
          "location": "Acolher convivência sênior",
          "kind": "class"
        }
      }
    },
    "2": {
      "am1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "1": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Bárbara Simões",
          "location": "Sala 311",
          "kind": "pe"
        },
        "2": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Bárbara Simões",
          "location": "Sala 311",
          "kind": "pe"
        },
        "3": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Bárbara Simões",
          "location": "Sala 311",
          "kind": "pe"
        },
        "4": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Bárbara Simões",
          "location": "Sala 311",
          "kind": "pe"
        }
      },
      "pm1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        }
      },
      "pm2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        }
      }
    },
    "3": {
      "am1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm1": {
        "1": {
          "code": "PLa",
          "title": "Prática de laboratório de anatomia",
          "professor": "Sonaly Leal",
          "location": "Lab. Anatomia",
          "kind": "pl"
        },
        "2": {
          "code": "PLa",
          "title": "Prática de laboratório de anatomia",
          "professor": "Sonaly Leal",
          "location": "Lab. Anatomia",
          "kind": "pl"
        },
        "3": {
          "code": "PLpc",
          "title": "Prática de laboratório",
          "professor": "Josiane Quetz",
          "location": "Lab. Histologia",
          "kind": "pl"
        },
        "4": {
          "code": "PLpc",
          "title": "Prática de laboratório",
          "professor": "Josiane Quetz",
          "location": "Lab. Histologia",
          "kind": "pl"
        }
      },
      "pm2": {
        "1": {
          "code": "PLpc",
          "title": "Prática de laboratório",
          "professor": "Josiane Quetz",
          "location": "Lab. Histologia",
          "kind": "pl"
        },
        "2": {
          "code": "PLpc",
          "title": "Prática de laboratório",
          "professor": "Josiane Quetz",
          "location": "Lab. Histologia",
          "kind": "pl"
        },
        "3": {
          "code": "PLa",
          "title": "Prática de laboratório de anatomia",
          "professor": "Sonaly Leal",
          "location": "Lab. Anatomia",
          "kind": "pl"
        },
        "4": {
          "code": "PLa",
          "title": "Prática de laboratório de anatomia",
          "professor": "Sonaly Leal",
          "location": "Lab. Anatomia",
          "kind": "pl"
        }
      }
    },
    "4": {
      "am1": {
        "1": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Ewerton",
          "location": "Lar das idosas Sta Tereza e Sta Terezinha",
          "kind": "class"
        },
        "2": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Ewerton",
          "location": "Lar das idosas Sta Tereza e Sta Terezinha",
          "kind": "class"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Maria Cecília",
          "location": "Simulação",
          "kind": "th"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "1": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Ewerton",
          "location": "Lar das idosas Sta Tereza e Sta Terezinha",
          "kind": "class"
        },
        "2": {
          "code": "PMCp",
          "title": "Prática médica na comunidade · prática",
          "professor": "Ewerton",
          "location": "Lar das idosas Sta Tereza e Sta Terezinha",
          "kind": "class"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Maria Cecília",
          "location": "Simulação",
          "kind": "th"
        }
      },
      "pm1": {
        "1": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Lara Bignoto",
          "location": "Simulação",
          "kind": "th"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Lara Bignoto",
          "location": "Simulação",
          "kind": "th"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    },
    "5": {
      "am1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        }
      },
      "am2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "Consultar Secretaria",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "",
          "location": "",
          "kind": "gt"
        }
      },
      "pm1": {
        "1": {
          "code": "Seminário",
          "title": "Seminário",
          "professor": "Vários",
          "location": "Auditório",
          "kind": "class"
        },
        "2": {
          "code": "Seminário",
          "title": "Seminário",
          "professor": "Vários",
          "location": "Auditório",
          "kind": "class"
        },
        "3": {
          "code": "Seminário",
          "title": "Seminário",
          "professor": "Vários",
          "location": "Auditório",
          "kind": "class"
        },
        "4": {
          "code": "Seminário",
          "title": "Seminário",
          "professor": "Vários",
          "location": "Auditório",
          "kind": "class"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    }
  }
},
  baseScheduleByLetter: {
  "geral": {
    "A": {
      "1": {
        "am1": {
          "1": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          },
          "2": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          },
          "3": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          },
          "4": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Alice Medeiros",
            "location": "Acolher convivência sênior",
            "kind": "class"
          },
          "4": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Alice Medeiros",
            "location": "Acolher convivência sênior",
            "kind": "class"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Alice Medeiros",
            "location": "Acolher convivência sênior",
            "kind": "class"
          },
          "4": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Alice Medeiros",
            "location": "Acolher convivência sênior",
            "kind": "class"
          }
        }
      },
      "2": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Bárbara Simões",
            "location": "Sala 311",
            "kind": "pe"
          },
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Bárbara Simões",
            "location": "Sala 311",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Bárbara Simões",
            "location": "Sala 311",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Bárbara Simões",
            "location": "Sala 311",
            "kind": "pe"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "2": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "3": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Josiane Quetz",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "4": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Josiane Quetz",
            "location": "Lab. Histologia",
            "kind": "pl"
          }
        },
        "pm2": {
          "1": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Josiane Quetz",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "2": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Josiane Quetz",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "3": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "4": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          }
        }
      },
      "4": {
        "am1": {
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Ewerton",
            "location": "Lar das idosas Sta Tereza e Sta Terezinha",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Ewerton",
            "location": "Lar das idosas Sta Tereza e Sta Terezinha",
            "kind": "class"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Maria Cecília",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Ewerton",
            "location": "Lar das idosas Sta Tereza e Sta Terezinha",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Ewerton",
            "location": "Lar das idosas Sta Tereza e Sta Terezinha",
            "kind": "class"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Maria Cecília",
            "location": "Simulação",
            "kind": "th"
          }
        },
        "pm1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Lara Bignoto",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Lara Bignoto",
            "location": "Simulação",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "2": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "3": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "4": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      }
    },
    "B": {
      "1": {
        "am1": {
          "1": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          },
          "2": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          },
          "4": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          }
        },
        "pm1": {
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Fernanda Amorim",
            "location": "Lar dona Paula",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Fernanda Amorim",
            "location": "Lar dona Paula",
            "kind": "class"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Fernanda Amorim",
            "location": "Lar dona Paula",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Fernanda Amorim",
            "location": "Lar dona Paula",
            "kind": "class"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "2": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Bruna França",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Bruna França",
            "location": "Simulação",
            "kind": "th"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Carla Simões",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Carla Simões",
            "location": "Simulação",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Fernanda Amorim",
            "location": "Lar dona Paula",
            "kind": "class"
          },
          "4": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Fernanda Amorim",
            "location": "Lar dona Paula",
            "kind": "class"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Fernanda Amorim",
            "location": "Lar dona Paula",
            "kind": "class"
          },
          "4": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Fernanda Amorim",
            "location": "Lar dona Paula",
            "kind": "class"
          }
        }
      },
      "4": {
        "am1": {
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Lidiane Sousa",
            "location": "Sala 301",
            "kind": "pe"
          },
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Lidiane Sousa",
            "location": "Sala 301",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Lidiane Sousa",
            "location": "Sala 301",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Lidiane Sousa",
            "location": "Sala 301",
            "kind": "pe"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "2": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "4": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Sonaly Leal",
            "location": "Lab. Anatomia",
            "kind": "pl"
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "2": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "3": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Josiane Quetz",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "4": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Josiane Quetz",
            "location": "Lab. Histologia",
            "kind": "pl"
          }
        },
        "pm2": {
          "1": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Josiane Quetz",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "2": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Josiane Quetz",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "3": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "4": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          }
        }
      }
    },
    "C": {
      "1": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          },
          "2": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          },
          "3": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          },
          "4": {
            "code": "PMCo",
            "title": "Prática médica na comunidade · oficina",
            "professor": "Renata Lima",
            "location": "Sala301",
            "kind": "class"
          }
        },
        "pm1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Eduardo Cabral",
            "location": "Simulação",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Eduardo Cabral",
            "location": "Simulação",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "2": {
        "am1": {
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Rodrigo Lara",
            "location": "Casa do Ancião Chichico Azevedo",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Rodrigo Lara",
            "location": "Casa do Ancião Chichico Azevedo",
            "kind": "class"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Rodrigo Lara",
            "location": "Casa do Ancião Chichico Azevedo",
            "kind": "class"
          },
          "2": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Rodrigo Lara",
            "location": "Casa do Ancião Chichico Azevedo",
            "kind": "class"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Rodrigo Lara",
            "location": "Casa do Ancião Chichico Azevedo",
            "kind": "class"
          },
          "4": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Rodrigo Lara",
            "location": "Casa do Ancião Chichico Azevedo",
            "kind": "class"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Rodrigo Lara",
            "location": "Casa do Ancião Chichico Azevedo",
            "kind": "class"
          },
          "4": {
            "code": "PMCp",
            "title": "Prática médica na comunidade · prática",
            "professor": "Rodrigo Lara",
            "location": "Casa do Ancião Chichico Azevedo",
            "kind": "class"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Carla Simões",
            "location": "Simulação",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Carla Simões",
            "location": "Simulação",
            "kind": "th"
          }
        }
      },
      "4": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Lidiane Sousa",
            "location": "Sala 301",
            "kind": "pe"
          },
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Lidiane Sousa",
            "location": "Sala 301",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Lidiane Sousa",
            "location": "Sala 301",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Lidiane Sousa",
            "location": "Sala 301",
            "kind": "pe"
          }
        },
        "pm1": {
          "1": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Walter Lozada",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "2": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Walter Lozada",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "3": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Eliane Perlato",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "4": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Eliane Perlato",
            "location": "Lab. Histologia",
            "kind": "pl"
          }
        },
        "pm2": {
          "1": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Eliane Perlato",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "2": {
            "code": "PLpc",
            "title": "Prática de laboratório",
            "professor": "Eliane Perlato",
            "location": "Lab. Histologia",
            "kind": "pl"
          },
          "3": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Walter Lozada",
            "location": "Lab. Anatomia",
            "kind": "pl"
          },
          "4": {
            "code": "PLa",
            "title": "Prática de laboratório de anatomia",
            "professor": "Walter Lozada",
            "location": "Lab. Anatomia",
            "kind": "pl"
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "Consultar Secretaria",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "",
            "location": "",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "2": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "3": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          },
          "4": {
            "code": "Seminário",
            "title": "Seminário",
            "professor": "Vários",
            "location": "Auditório",
            "kind": "class"
          }
        }
      }
    }
  }
},
  fixedClinics: {},
  specialtyClinics: {},
  extraCatalog: [],
  sourcePdf
};
export default periodDataset;
